if (!customElements.get('teema-promotion')) {
  customElements.define('teema-promotion', class extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      const end = this.dataset.endsAt;
      if (end) {
        const expiresAt = Date.parse(end);
        const expire = () => {
          if (!Number.isFinite(expiresAt) || Date.now() >= expiresAt) {
            this.hidden = true;
            clearInterval(this.expiryTimer);
            return true;
          }
          return false;
        };
        if (expire()) return;
        this.expiryTimer = setInterval(expire, 1000);
        document.addEventListener('visibilitychange', expire, { signal });
      }

      const viewport = this.querySelector('.teema-promotion__viewport');
      if (!viewport || this.dataset.autoscroll === 'false') return;
      this.motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
      const updateMotion = () => {
        this.toggleAttribute('data-animated', !this.motionPreference.matches);
      };
      this.motionPreference.addEventListener('change', updateMotion, { signal });
      updateMotion();
      this.resizeObserver = new ResizeObserver(() => {
        this.style.setProperty('--teema-rail-width', `${viewport.clientWidth}px`);
      });
      this.resizeObserver.observe(viewport);

    }

    disconnectedCallback() {
      clearInterval(this.expiryTimer);
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
